import {GoogleMap, Marker, Polygon, Polyline, withGoogleMap, withScriptjs} from "react-google-maps";
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

function initialPositionAndFirstWP(areaCoveragePath, index, initialPositionsRefs) {

    if(!areaCoveragePath || !areaCoveragePath.length > 0 || !initialPositionsRefs || !initialPositionsRefs[index]) {
        return []
    }

    const point = initialPositionsRefs[index].getPosition();


    if(!point) {
        return []
    }

    let firstPoint = areaCoveragePath[0]
    return [firstPoint,  {lat: point.lat(), lng: point.lng()} ]
}

class InternalMap extends React.Component {



    componentDidMount() {


    }



    render() {
        const {
            mapLocation,
            project,
            initialUAVPosition,
            setAreaOfInterestRef,
            setNoFlyZonePolygonRef,
            setInitialPositionRef,
            setScatteredRegionsOfInterestRefs,
            polygonBackgroundColor,
            polygonBackgroundColorCheck,
            dronesConfig,
            dronesLive,
            initialPositionsRefs
        } = this.props;

        console.log("Inside custom map: ", this.props.dronesLive)

        // debugger
        let markerClass = {
            color: "white",
            "background-color": "white",
            "text-shadow": "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000"
        }
        console.log(`INSIDE CUSTOMMAP`)
            console.log(this.props);
        initialUAVPosition ? console.log("ok") : console.log("NULL!")
        return (
            <GoogleMap defaultZoom={16} defaultCenter={mapLocation} mapTypeId={"satellite"}
                       center={mapLocation} ref={(node) => this.props.setMapRef(node)}>

                {project && project.initialPositions?
                    project.initialPositions.map((pos, index) =>
                <Marker
                    ref={(node) => setInitialPositionRef(node, index)}
                    position={pos}
                    label={{text:project.type === 'AREA_COVERAGE' ? `UAV ${index + 1}`: 'Take-off position',color:'#daa520', fontSize: '20px', fontWeight: "600", className : "markerClass"}}
                    draggable={this.props.editingPolygons}
                    editable={this.props.editingPolygons}
                />) :null}


                {project && project.type === 'AREA_COVERAGE' && project.areaOfInterest ?
                    (<Polygon
                        ref={(node) => setAreaOfInterestRef(node)}
                        myIndex={0}
                        paths={project.areaOfInterest}

                        options={polygonBackgroundColorCheck ? {fillColor: polygonBackgroundColor, fillOpacity: 1,  zIndex: 9000}
                            : {fillColor: '#000000', fillOpacity: 0.27}}
                        // options={{fillColor: '#FFFFFF', fillOpacity: 1}}
                        // strokeColor='#00CCCC'
                        // strokeColor='#FFFFFF'
                        // strokeOpacity={0.8}
                        // strokeWeight={2}
                        // fillColor={'#003333'}
                        fillColor={'#FFFFFF'}
                        // fillOpacity={1}
                        // onRightClick={(evt) => {this.props.deletePolygon(0)}}
                        draggable={this.props.editingPolygons}
                        editable={this.props.editingPolygons}
                        />) : null }

                {project && project.type === 'AREA_COVERAGE' && project.noFlyZones ? project.noFlyZones.map((noFlyZone, index) =>
                        <Polygon
                            ref={(node) => setNoFlyZonePolygonRef(node, index)}
                            myIndex={index}
                            paths={noFlyZone}
                            options={{zIndex: 9001, fillOpacity: 0.6, strokeColor: "crimson"}}
                            draggable={this.props.editingPolygons}
                            editable={this.props.editingPolygons}
                            onRightClick={(evt) => {this.props.onRemoveNoFlyZone(index)}}
                        />)
                    : null}

                {project && project.type ===  'SCATTERED_REGIONS_VISITATION' && project.scatteredRegionsOfInterest ?
                    project.scatteredRegionsOfInterest.map((area, index) =>

                    <Polygon
                        ref={(node) => setScatteredRegionsOfInterestRefs(node, index)}
                        myIndex={index}
                        paths={area}

                        options={polygonBackgroundColorCheck ? {fillColor: polygonBackgroundColor, fillOpacity: 1,  zIndex: 9000} : {fillColor: '#000000', fillOpacity: 0.27}}
                        // options={{fillColor: '#FFFFFF', fillOpacity: 1}}
                        // strokeColor='#00CCCC'
                        // strokeColor='#FFFFFF'
                        // strokeOpacity={0.8}
                        // strokeWeight={2}
                        // fillColor={'#003333'}
                        fillColor={'#FFFFFF'}
                        // fillOpacity={1}
                        onRightClick={(evt) => {this.props.deletePolygon(index)}}
                        draggable={this.props.editingPolygons}
                        editable={this.props.editingPolygons}
                    />) : null }




                {project && project.type === 'AREA_COVERAGE' && project.areaCoveragePaths ?


                    project.areaCoveragePaths.map((areaCoveragePath, index) => <div>
                        <Polyline
                            path={initialPositionAndFirstWP(areaCoveragePath, index, initialPositionsRefs)}
                            geodesic={true}
                            options={{
                                zIndex: 9001,
                                color: project.areaCoveragePathColors[index],
                                strokeColor: project.areaCoveragePathColors[index],
                                strokeOpacity: 0.6,
                                strokeWeight: 1,
                                icons: [
                                    {
                                        // icon: lineSymbol,
                                        offset: "0",
                                        repeat: "20px"
                                    }
                                ]
                            }}/>
                        <Polyline
                            key={index}
                            path={areaCoveragePath}
                            geodesic={true}
                            options={{
                                zIndex: 9001,
                                color: project.areaCoveragePathColors[index],
                                strokeColor: project.areaCoveragePathColors[index],
                            // strokeOpacity: 1,
                                strokeWeight: 3,
                                icons: [
                                    {
                                        // icon: lineSymbol,
                                        offset: "0",
                                        repeat: "20px"
                                    }
                                ]
                            }}
                        />
                    </div> ) : project && project.type === 'SCATTERED_REGIONS_VISITATION' && project.scatteredRegionsVisitationPaths ?
                        project.scatteredRegionsVisitationPaths.map((scatteredRegionsVisitationPath, index) => <Polyline
                            key={index}
                            path={scatteredRegionsVisitationPath.waypoints.map(extendedWaypoint => {

                                        return {lat: extendedWaypoint.waypoint.point.coordinates[1], lng: extendedWaypoint.waypoint.point.coordinates[0]}})}
                            geodesic={true}
                            options={{
                                zIndex: 9001,
                                color: project.scatteredRegionsVisitationPathColors[index],
                                strokeColor: project.scatteredRegionsVisitationPathColors[index],
                                // strokeOpacity: 1,
                                strokeWeight: 3,
                                icons: [
                                    {
                                        // icon: lineSymbol,
                                        offset: "0",
                                        repeat: "20px"
                                    }
                                ]
                            }}
                        /> ) : null
                }

                {project && project.type === 'SCATTERED_REGIONS_VISITATION' && project.fov ?
                    project.fov.coordinates.map(fovPolygon => {

                            let regionExteriorRing = [...fovPolygon[0]]
                            regionExteriorRing.pop()

                            let paths = regionExteriorRing.map(point => {
                                return {lat: point[1], lng: point[0]}
                            })
                            return <Polygon
                                paths={paths}
                                options={{zIndex: 9001, fillOpacity: 0.6, strokeColor: "#2596be"}}
                            />
                    }

                    )
                    : null}


                {Object.keys(this.props.dronesSubscribed).map(key => {

                    const droneSubscribed = this.props.dronesSubscribed[key];

                    const drone = dronesLive[key];

                    // console.log(drone);
                    let droneIcon = {
                        path: 'M1540 9813 c-203 -22 -493 -130 -695 -261 -234 -150 -452 -370 -596 -602 -103 -166 -199 -400 -233 -572 -23 -112 -23 -645 0 -779 32 -188 134 -443 248 -619 98 -151 321 -384 486 -509 136 -102 326 -200 493 -255 168 -55 272 -69 555 -74 362 -6 450 9 746 124 l141 55 40 -44 c99 -108 318 -420 362 -514 36 -78 43 -207 43 -853 0 -617 -7 -769 -38 -841 -38 -87 -324 -492 -390 -552 -16 -15 -30 -12 -169 43 -201 79 -318 108 -483 121 -163 13 -465 5 -587 -17 -206 -35 -497 -160 -683 -292 -104 -74 -319 -277 -403 -380 -133 -164 -235 -348 -306 -555 -70 -204 -73 -229 -69 -628 l4 -354 32 -107 c90 -302 238 -557 456 -785 267 -280 569 -451 951 -540 114 -26 614 -26 752 0 222 41 507 163 693 294 125 89 375 339 460 461 162 231 265 474 307 722 23 140 22 559 -2 694 -17 100 -66 254 -131 415 l-34 85 27 29 c72 75 443 336 538 378 75 33 191 38 845 38 654 0 770 -5 845 -38 92 -41 407 -261 519 -363 l47 -43 -31 -75 c-56 -134 -120 -332 -134 -415 -33 -190 -28 -552 9 -756 45 -238 154 -485 305 -688 128 -173 378 -406 535 -501 319 -192 576 -260 972 -260 343 1 551 44 808 170 225 110 413 256 597 466 123 140 184 230 262 388 79 160 119 272 146 411 17 92 20 145 20 399 0 308 -8 388 -51 545 -48 171 -160 397 -272 546 -112 150 -354 382 -497 477 -96 63 -312 169 -414 202 -208 68 -503 98 -786 78 -218 -14 -337 -47 -657 -179 -14 -6 -93 89 -216 257 -247 338 -257 377 -238 854 10 240 10 366 0 600 -17 417 -4 489 126 687 89 136 245 345 287 386 l34 33 114 -46 c252 -100 476 -144 730 -144 518 0 930 165 1294 519 269 263 439 553 521 893 24 99 25 115 25 438 0 323 -1 339 -25 438 -103 427 -371 815 -749 1087 -121 87 -339 195 -493 245 -193 63 -278 72 -618 67 -323 -5 -363 -11 -587 -93 -462 -170 -873 -560 -1069 -1015 -97 -225 -139 -448 -139 -745 0 -263 47 -495 151 -743 l39 -95 -22 -24 c-30 -32 -235 -186 -363 -272 -210 -141 -259 -155 -525 -154 -107 1 -230 4 -272 8 l-78 8 0 169 0 169 130 0 c146 0 196 13 204 52 10 50 16 1370 6 1389 -20 36 -51 44 -206 49 l-152 5 134 155 133 155 0 101 c1 77 -2 103 -13 107 -30 12 -771 19 -798 8 -28 -10 -28 -11 -28 -108 l1 -98 128 -155 129 -155 -148 -5 c-131 -4 -152 -8 -177 -26 l-28 -21 -6 -234 c-4 -129 -7 -444 -8 -700 -1 -461 -1 -466 20 -485 18 -16 42 -20 178 -24 l156 -5 3 -172 2 -172 -33 -6 c-18 -4 -132 -7 -253 -8 -238 -2 -291 6 -398 60 -97 49 -388 254 -494 349 l-44 39 50 125 c100 252 126 367 137 605 12 251 -20 533 -81 719 -34 105 -139 321 -202 416 -96 144 -331 388 -484 504 -212 159 -491 273 -761 311 -94 14 -506 19 -607 8z m522 -339 c484 -80 902 -389 1122 -829 166 -330 205 -670 117 -1019 -28 -109 -82 -258 -103 -283 -14 -17 10 -32 -393 260 -316 230 -467 345 -481 368 -6 10 -44 174 -44 190 0 5 44 57 98 116 154 171 206 232 267 318 66 91 135 227 135 264 0 34 -37 71 -71 71 -75 0 -294 -145 -495 -328 -177 -160 -195 -174 -224 -169 -134 26 -157 28 -224 17 -174 -26 -327 -155 -387 -326 -17 -50 -20 -75 -15 -164 3 -58 8 -119 11 -136 6 -28 0 -39 -57 -103 -217 -246 -266 -306 -328 -397 -61 -92 -110 -193 -110 -228 0 -27 41 -66 69 -66 37 0 171 67 256 128 78 55 193 152 341 285 88 80 101 88 129 83 16 -3 57 -10 89 -15 45 -8 68 -18 94 -43 40 -38 252 -319 472 -627 175 -244 171 -218 44 -271 -195 -81 -461 -121 -667 -101 -614 62 -1131 475 -1315 1052 -57 178 -67 246 -67 459 0 218 10 288 71 470 150 451 519 820 969 969 230 76 461 94 697 55z m6138 -1 c617 -99 1112 -572 1252 -1194 31 -139 33 -445 5 -579 -118 -554 -508 -991 -1039 -1164 -158 -51 -228 -61 -463 -61 -229 0 -263 5 -435 62 -118 39 -203 79 -198 94 8 24 550 759 598 811 51 54 60 60 115 69 33 5 74 12 91 15 27 5 41 -4 155 -106 295 -266 496 -401 580 -388 12 2 31 15 42 30 20 27 20 29 4 80 -33 105 -148 271 -315 454 -176 194 -175 193 -165 239 4 22 8 90 8 150 0 99 -3 116 -28 169 -39 83 -92 150 -162 203 -119 90 -234 117 -374 89 -98 -20 -87 -25 -211 90 -206 190 -338 292 -461 353 -91 46 -129 51 -159 21 -68 -68 53 -270 382 -633 54 -59 98 -111 98 -116 0 -4 -9 -47 -19 -95 -13 -59 -27 -96 -43 -113 -34 -37 -442 -339 -801 -593 -56 -40 -52 -43 -96 71 -98 254 -129 544 -87 794 92 537 485 1003 996 1183 246 86 474 106 730 65z m-6232 -6124 c155 -16 328 -61 455 -116 31 -14 57 -29 57 -33 0 -9 -300 -428 -470 -656 -134 -179 -177 -224 -214 -224 -12 0 -48 -7 -81 -15 -71 -19 -59 -26 -248 145 -229 205 -431 340 -512 340 -47 0 -78 -34 -72 -76 16 -101 147 -292 367 -534 l131 -145 -7 -40 c-5 -22 -8 -92 -9 -155 0 -109 2 -118 33 -184 43 -92 151 -200 246 -247 61 -29 81 -34 165 -37 67 -3 112 0 148 11 51 15 52 15 86 -11 19 -15 88 -76 153 -135 288 -263 498 -382 566 -320 28 25 22 70 -22 158 -50 102 -164 252 -324 428 -69 76 -128 147 -131 158 -4 11 -2 34 4 52 5 17 13 53 17 80 6 42 13 54 64 100 79 71 800 597 819 597 12 0 64 -126 94 -231 100 -342 76 -701 -68 -1022 -177 -398 -523 -707 -940 -840 -156 -50 -241 -61 -465 -61 -170 0 -207 3 -290 23 -459 113 -823 392 -1029 791 -117 228 -160 392 -168 646 -5 136 -2 193 12 275 56 334 197 605 444 849 319 316 762 476 1189 429z m6262 -14 c605 -118 1074 -571 1217 -1175 36 -156 43 -391 15 -555 -37 -217 -115 -413 -239 -600 -87 -131 -292 -337 -417 -419 -169 -112 -408 -209 -581 -237 -120 -20 -451 -17 -545 5 -622 141 -1070 595 -1201 1216 -29 139 -32 381 -6 515 32 158 102 370 132 395 15 13 74 -27 515 -349 327 -238 364 -272 375 -341 3 -25 11 -60 16 -77 6 -18 8 -41 4 -52 -3 -11 -62 -82 -131 -158 -160 -176 -274 -326 -324 -428 -43 -87 -49 -128 -23 -157 60 -67 269 50 559 312 70 63 142 127 161 142 34 26 35 26 86 11 36 -11 81 -14 148 -11 84 3 104 8 165 37 94 46 199 152 245 246 33 67 34 73 34 185 -1 63 -4 133 -9 155 l-7 40 131 145 c221 244 350 432 367 533 7 45 -22 77 -71 77 -82 0 -284 -134 -513 -340 -191 -172 -175 -164 -258 -144 -39 8 -80 18 -92 20 -12 2 -48 35 -81 74 -70 83 -582 785 -582 798 0 18 176 85 318 122 163 42 420 48 592 15z',
                        fillColor:  droneSubscribed.publishesTelemetry? '#4cff00' : '#808080',
                        fillOpacity: 1,
                        scale: 0.003,
                        // strokeColor: 'gold',
                        // strokeWeight: 14,
                        rotation: drone? drone.heading : 0
                    };


                    let location;
                    if(drone && droneSubscribed.publishesTelemetry) {
                        location = {lat: drone.location.lat,lng: drone.location.lng};
                    } else {
                        location = droneSubscribed.lastTelemetry
                    }
                    return (
                        <Marker
                            key={key}
                            position={location}
                            // icon={activeDroneImg}
                            icon={droneIcon}
                            // rotation={drone.heading}
                            // options={{ rotation: 1, position: {lat: drone.location.lat, lng: drone.location.lng}}}
                            // options={{rotation : 1}}
                            />
                    )
                })}

            </GoogleMap>

        );
    }
}

const MapHoc = withScriptjs(withGoogleMap(InternalMap));

class CustomMap extends React.Component {


    render() {

        return (
            <MapHoc
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCrFkoy3GLop2K12MeTHY0hwwvj8M_LToY&v=3.exp&libraries=geometry,drawing,places"
                // loadingElement={<div className='loader' style={{height: '80vh'}}>Loading...</div>}
                loadingElement={ <CircularProgress style={{height: `80vh`}}/> }
                containerElement={<div style={{height: `100%`}}/>}
                mapElement={<div style={{height: `100%`}}/>}

                project = {this.props.project}

                mapLocation={this.props.mapLocation}
                initialLocation={this.props.initialLocation}
                initialUAVPosition={this.props.initialUAVPosition}
                resetOperationalArea={this.props.resetOperationalArea}


                mission={this.props.mission}
                setMapRef={this.props.setMapRef}

                setAreaOfInterestRef={this.props.setAreaOfInterestRef}
                setNoFlyZonePolygonRef={this.props.setNoFlyZonePolygonRef}


                setScatteredRegionsOfInterestRefs={this.props.setScatteredRegionsOfInterestRefs}
                initialPositionsRefs={this.props.initialPositionsRefs}
                refreshDronesSubscribed={this.props.refreshDronesSubscribed}
                dronesConfig={this.props.dronesConfig}
                dronesSubscribed={this.props.dronesSubscribed}
                dronesLive={this.props.dronesLive}
                polygonBackgroundColor={this.props.polygonBackgroundColor}
                polygonBackgroundColorCheck={this.props.polygonBackgroundColorCheck}
                obstaclePaths={this.props.obstaclePaths}
                onRemoveNoFlyZone={this.props.onRemoveNoFlyZone}
                deletePolygon={this.props.deletePolygon}
                setInitialPositionRef={this.props.setInitialPositionRef}
                editingPolygons={this.props.editingPolygons}
            />
        )
    }
}

export default CustomMap;


